import { render, staticRenderFns } from "./columnManagement.vue?vue&type=template&id=ce2d1ce8&"
import script from "./columnManagement.vue?vue&type=script&lang=js&"
export * from "./columnManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports